'use strict';
import Editables from './modules/editables';
import Helper from './modules/helper';
import BulkEdit from './modules/bulk-edit';
import InlineEdit from './modules/inline-edit';
import ColumnMiddleware from './middleware/columns';
import CellMiddleware from './middleware/cells';
import TableUpdate from './modules/table-update';
import { getEditableValues } from "./helpers/ajax";
require('admin-columns-js/polyfill/customevent');
require('admin-columns-js/polyfill/nodelist');
require('./helpers/polyfill');
/*
 * DOM ready
 */
var isStoredListScreen = function () {
    return AC.hasOwnProperty('layout') && null !== AC.layout;
};
AdminColumns.events.on('Table.Ready', function (e) {
    if (!AdminColumns.hasOwnProperty('Table') || !isStoredListScreen()) {
        return;
    }
    ColumnMiddleware.map(AdminColumns.Table.Columns, ACP_Editing_Columns);
    AdminColumns.Editing = {};
    AdminColumns.Editing.Editables = new Editables();
    AdminColumns.Editing.Editables.initEditables();
    AdminColumns.Editing.Helper = Helper;
    if (hasBulkEditColumns(ACP_Editing_Columns)) {
        AdminColumns.Editing.BulkEdit = new BulkEdit(AdminColumns.Table, AdminColumns.Editing.Editables);
        require('./modules/bulk-modal');
    }
    AdminColumns.Editing.TableUpdate = new TableUpdate();
    if (hasInlineEditColumns(ACP_Editing_Columns)) {
        var Editing_items = getEditableValues(AdminColumns.Table.getIdsFromTable());
        Editing_items.done(function (response) {
            if (!response.success || !response.data) {
                console.info('Admin Columns Inline Edit could not be loaded');
                return;
            }
            if (!response.data.hasOwnProperty('editable_values')) {
                return;
            }
            var ie_enabled = (ACP_Editing.inline_edit.hasOwnProperty('active') && ACP_Editing.inline_edit.active);
            if (ACP_Editing.inline_edit.hasOwnProperty('persistent') && ACP_Editing.inline_edit.persistent) {
                ie_enabled = true;
            }
            CellMiddleware(AdminColumns.Table.Cells, response.data.editable_values);
            AdminColumns.Editing.InlineEdit = new InlineEdit(AdminColumns.Table, AdminColumns.Editing.Editables, ie_enabled, ACP_Editing.inline_edit.version);
        });
    }
    else {
        var ieditToggle = document.querySelector('.ac-table-button.-toggle.-iedit');
        if (ieditToggle) {
            ieditToggle.remove();
        }
    }
});
var hasInlineEditColumns = function (columns) {
    for (var _i = 0, _a = Object.keys(columns); _i < _a.length; _i++) {
        var column_name = _a[_i];
        var settings = columns[column_name];
        if (settings.hasOwnProperty('inline_edit') && settings.inline_edit) {
            return true;
        }
    }
    return false;
};
var hasBulkEditColumns = function (columns) {
    for (var _i = 0, _a = Object.keys(columns); _i < _a.length; _i++) {
        var column_name = _a[_i];
        var settings = columns[column_name];
        if (settings.hasOwnProperty('bulk_edit') && settings.bulk_edit) {
            return true;
        }
    }
    return false;
};
